namespace TabAurous.Reports {
    export interface StoneBifurcationRow {
        TransId?: number;
        TransItemId?: number;
        ProductId?: number;
        AttributeId?: number;
        Status?: string;
        Image?: string;
        ImageLength?: number;
        ProductCode?: string;
        ProductName?: string;
        StampCode?: string;
        ProductSizeCode?: string;
        SuperTypeCode?: string;
        RefNo?: string;
        Pieces?: number;
        CompanyCode?: string;
        DeptName?: string;
        Purity?: number;
        PureWeight?: number;
        MetalGrossWeight?: number;
        MetalNetWeight?: number;
        MetalNetAmount?: number;
        KaratId?: number;
        MetalName?: string;
        MetalColorName?: string;
        ProductLink?: string;
        DiamondType?: string;
        DiamondPieces?: number;
        DiamondWeight?: number;
        TotalDiamondWeight?: number;
        DiamondRate?: number;
        DiamondAmount?: number;
        PreciousStoneType?: string;
        PreciousStonePieces?: number;
        TotalPreciousStoneWeight?: number;
        PreciousStoneWeight?: number;
        SemiPreciousStoneType?: string;
        SemiPreciousStonePieces?: number;
        TotalSemiPreciousStoneWeight?: number;
        SemiPreciousStoneWeight?: number;
        Discount?: number;
        GrossAmount?: number;
        Remark?: string;
        MF?: number;
        MFAmount?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
    }

    export namespace StoneBifurcationRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'Reports.StoneBifurcation';
        export const deletePermission = 'Reports:Transaction:Stone Bifurcation';
        export const insertPermission = 'Reports:Transaction:Stone Bifurcation';
        export const readPermission = 'Reports:Transaction:Stone Bifurcation';
        export const updatePermission = 'Reports:Transaction:Stone Bifurcation';

        export declare const enum Fields {
            TransId = "TransId",
            TransItemId = "TransItemId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Status = "Status",
            Image = "Image",
            ImageLength = "ImageLength",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            StampCode = "StampCode",
            ProductSizeCode = "ProductSizeCode",
            SuperTypeCode = "SuperTypeCode",
            RefNo = "RefNo",
            Pieces = "Pieces",
            CompanyCode = "CompanyCode",
            DeptName = "DeptName",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MetalGrossWeight = "MetalGrossWeight",
            MetalNetWeight = "MetalNetWeight",
            MetalNetAmount = "MetalNetAmount",
            KaratId = "KaratId",
            MetalName = "MetalName",
            MetalColorName = "MetalColorName",
            ProductLink = "ProductLink",
            DiamondType = "DiamondType",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            TotalDiamondWeight = "TotalDiamondWeight",
            DiamondRate = "DiamondRate",
            DiamondAmount = "DiamondAmount",
            PreciousStoneType = "PreciousStoneType",
            PreciousStonePieces = "PreciousStonePieces",
            TotalPreciousStoneWeight = "TotalPreciousStoneWeight",
            PreciousStoneWeight = "PreciousStoneWeight",
            SemiPreciousStoneType = "SemiPreciousStoneType",
            SemiPreciousStonePieces = "SemiPreciousStonePieces",
            TotalSemiPreciousStoneWeight = "TotalSemiPreciousStoneWeight",
            SemiPreciousStoneWeight = "SemiPreciousStoneWeight",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            MF = "MF",
            MFAmount = "MFAmount",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId"
        }
    }
}
